import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('jw.tooltip', []).directive('jwTooltip', jwTooltip);

    function jwTooltip($document, $compile) {
        return {
            restrict: 'A',
            scope: true,
            link: function (scope, element, attrs) {
                var tooltip = $compile(
                    "<div id='jwTooltip' ng-class='tipClass' ng-bind-html='information | TrustedHtml'></div>"
                )(scope);
                var tooltipClassName = 'jw-tooltip';
                var tooltipActiveClassName = 'jw-tooltip-show';

                scope.tipClass = [tooltipClassName];
                scope.information = attrs.jwTooltip;

                element.bind('mouseover', function (e) {
                    $document.find('body').append(tooltip);
                    tooltip.addClass(tooltipActiveClassName);

                    var bodyRect = document.body.getBoundingClientRect(),
                        pos = e.target.getBoundingClientRect(),
                        elOffset = pos.top - bodyRect.top,
                        offset = tooltip.offset(),
                        tipHeight = tooltip.outerHeight(),
                        tipOffset = 5;

                    offset.top = elOffset - tipHeight - tipOffset;
                    offset.left = pos.left;

                    tooltip.offset(offset);
                });

                element.bind('click', function () {
                    angular.element('#jwTooltip').remove();
                    tooltip.removeClass(tooltipActiveClassName);
                });

                element.bind('mouseout', function () {
                    angular.element('#jwTooltip').remove();
                    tooltip.removeClass(tooltipActiveClassName);
                });
            },
        };
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/directives/jwTooltip/jwTooltip.directive.ts